import React from 'react'
import styled from 'styled-components'
import Layout from '../../components/Layout'
import { Grid } from 'rsuite'
import { motion } from 'framer-motion'
import { parentVariants } from '../../framerOptions'
import EventDetailCard from './EventDetailCard'
import Organizers from './Organizers'
import EventInformationCard from './EventInformationCard'
import Location from './Venue'

export default function Information () {
  return (
   <Layout.Container>
     <Container>
       <Layout.Title>Información</Layout.Title>
       <Grid fluid>
         <motion.div variants={parentVariants} initial="hidden" animate="visible">
           <EventDetailCard/>
           <EventInformationCard/>
           <Organizers/>
           <Location />
         </motion.div>
       </Grid>
     </Container>
    </Layout.Container>
  )
}

const Container = styled.div`
  
`